import { render } from "./ImagePupup.vue?vue&type=template&id=065918e9&scoped=true"
import script from "./ImagePupup.vue?vue&type=script&lang=js"
export * from "./ImagePupup.vue?vue&type=script&lang=js"

import "./ImagePupup.vue?vue&type=style&index=0&id=065918e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065918e9"]])

export default __exports__